import "./ProfileInventoryModel.css";
import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

function ProfileInventoryModel() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <div>
      <div>
        <Button variant="primary" onClick={handleShow}>
          Change Password
        </Button>

        <Modal
          show={show}
          onHide={handleClose}
          animation={false}
          centered
          className=" purchase-modal"
          size="xl"
        >
          <Modal.Header className="modal-header" closeButton>
            <Modal.Title className="modal-title">
              <h2 className="body-medium ">Purchase Terms and Conitions</h2>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="modal-body">
            <div className="first">
              <div className="left">
                <div className="pioneer-land-img">
                  <img
                    src="\assets\images\CanvasImage.png"
                    alt=""
                    className="img-fluid"
                  />
                </div>
                <div className="left-content">
                  <h3>Pioneer Land</h3>
                  <div className="icon-para d-flex align-content-center ">
                    <img src="\assets\images\MapCanvasIcon.svg" alt="" />
                    <p className="para text-light-green mb-0">28,200,52</p>
                  </div>
                </div>
              </div>
              <div className="right">
                <p>USDT 100.00</p>
              </div>
            </div>
            <div className="second">
              <div className="main">
                <div className="div-1">
                  <p>Subtotal:</p>
                  <h5>USDT 100.00</h5>
                </div>
                <div className="div-1">
                  <p>10% platform fee:</p>
                  <h5>USDT 10.00</h5>
                </div>
                <div className="div-1">
                  <p>5% tax:</p>
                  <h5>USDT 5.00</h5>
                </div>
              </div>
            </div>
          </Modal.Body>

          <div className="modal-footer">
            <div className="content">
              <p>Final Rent:</p>
              <h5>USDT 115.00</h5>
            </div>
            <div className="for-border">
              <div className="agree ">
                <div className="d-flex align-items-center mt-0">
                  <label htmlFor="chk">
                    <input type="checkbox" name="" id="chk" />I agree to the
                    terms of the Astrality purchase Agreement
                  </label>
                </div>
                <div className="list">
                  <h5>After purchase, this asset:</h5>
                  <ul>
                    <li>will not be tradable at initial stage</li>
                    <li>can rent out to advertiser</li>
                  </ul>
                </div>
              </div>
              <div className="footer-btn">
                <button className="back">Back to Offer</button>
                <button className="confirm">Confirm Rent</button>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </div>
  );
}

export default ProfileInventoryModel;
